export const DATA_MODULE_BANNER = (handleLegalsModal, handleModal) => ({
  cta: {
    nombre: 'Tu médico online 24h, donde y cuando quieras',
    legalsDescription: 'Contratación no disponible',
  },
  customClickEvent: handleModal,
  imgDeskFicha:
    '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-banner-pc.jpg',
  imgMobile:
    '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-banner-m.png',
});

export const MOVISTAR_SALUD_CARACTERISTICA = [
  {
    align: 'left',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-01-pc.png',
    altImage: 'telemedicina online',
    title: 'Qué incluye Movistar Salud',
    descriptionList: [
      {
        icon: 'Check',
        text: 'Consultas ilimitadas de medicina general',
      },
      {
        icon: 'Check',
        text: 'Recetas médicas',
      },
      {
        icon: 'Check',
        text: 'Equipo de nutricionistas',
      },
      {
        icon: 'Check',
        text: '1ª consulta de orientación psicológica',
      },
      {
        icon: 'Check',
        text: 'Preevaluación digital de síntomas',
      },
      {
        icon: 'Check',
        text: 'Programa Ponte en forma',
      },
    ],
  },
];

export const MODULO_DETALLES = [
  {
    align: 'left',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-04-pc.png',
    altImage: 'consulta online medico',
    subtitle: 'Atención de emergencias inmediata 24h',
    description:
      'Tienes a tu disposición un equipo de profesionales sanitarios que te atenderán 24 horas los 365 días del año',
    // textLink: 'Hablar con un médico en 30 min >',
    hrefLink: 'https://www.movistar.es',
  },
  {
    align: 'right',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-05-pc.png',
    altImage: 'consulta con doctor en linea',
    subtitle: 'Tus recetas sin moverte de casa',
    description:
      'Nuestros profesionales sanitarios te envían la receta al móvil para que la recibas cómodamente sin moverte de casa',
    // textLink: 'Conseguir receta >',
    hrefLink: 'https://www.movistar.es',
  },
  {
    align: 'left',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-06-pc.png',
    altImage: 'consulta medico online',
    subtitle: 'Consulta tus dudas médicas desde el móvil',
    description:
      'Un equipo multidisciplinar de sanitarios resolverá tus dudas de manera inmediata: no esperes a encontrarte mal. Te aclaramos cualquier pregunta sobre tu salud y la de tu familia, tu embarazo, vacunas, etc. de manera profesional.',
    // textLink: 'Consultar dudas >',
    hrefLink: 'https://www.movistar.es',
  },
  {
    align: 'right',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-07-pc.png',
    altImage: 'consulta online medico',
    subtitle: 'Consulta tus síntomas online',
    description:
      'Rellena unas preguntas desde tu app fáciles y rápidas y obtén un diagnóstico en minutos',
    // textLink: 'Consultar síntomas >',
    hrefLink: 'https://www.movistar.es',
  },
  {
    align: 'left',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-08-pc.png',
    altImage: 'medicos consulta online',
    subtitle: 'Programa Ponte en forma',
    description:
      'Plan de dieta y ejercicio con recetas y vídeos de ejercicios además de asesoramiento de nutricionistas',
    // textLink: 'Comenzar plan de ejercicio y dieta >',
    hrefLink: 'https://www.movistar.es',
  },
  {
    align: 'right',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-09-pc.png',
    altImage: 'consulta medicos online',
    subtitle: 'Personal sanitario profesional y certificado',
    description:
      'Un equipo multidisplinar de profesionales sanitarios, nutricionistas, entrenadores personales y psicólogos clínicos',
    // textLink: 'Hablar con un profesional >',
    hrefLink: 'https://www.movistar.es',
  },
];

export const MODULO_SERVICIOS_ADICIONALES = [
  {
    align: 'left',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-10-pc.png',
    altImage: 'consultas médico online',
    title: 'Servicios adicionales a tu elección',
    description:
      'Tienes a tu disposición los siguientes servicios de pago por uso',
    descriptionList: [
      {
        icon: 'Check',
        text: 'Médicos disponibles de hasta 8 especialidades',
      },
      {
        icon: 'Check',
        text: 'Médico a domicilio',
      },
      {
        icon: 'Check',
        text: 'Matrona a domicilio',
      },
      {
        icon: 'Check',
        text: 'Dietas personalizadas adaptadas a tus necesidades',
      },
      {
        icon: 'Check',
        text: 'Preparación de carrera',
      },
    ],
  },
];

export const MODULO_ESPECIALIDADES = [
  {
    align: 'right',
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-11-pc.png',
    altImage: 'app de doctores en linea',
    title: 'Especialidades desde 29€',
    urlButton: 'https://movistarsalud.es/',
    descriptionList: [
      {
        icon: 'Check',
        text: 'Psicología',
      },
      {
        icon: 'Check',
        text: 'Nutrición',
      },
      {
        icon: 'Check',
        text: 'Pediatría',
      },
      {
        icon: 'Check',
        text: 'Dermatología',
      },
      {
        icon: 'Check',
        text: 'Traumatología',
      },
      {
        icon: 'Check',
        text: 'Ginecología',
      },
      {
        icon: 'Check',
        text: 'Reumatología',
      },
    ],
  },
];

export const MODULO_PASOS = [
  {
    icon: 'Comprar',
    step: '1. Contrata el servicio en sus modalidades Personal o Familiar',
  },
  {
    icon: 'Usuario',
    step: '2. Entra en el portal de Movistar Salud y completa el registro',
  },
  {
    icon: 'Movil',
    step: '3. Pide cita y gestiónalas desde tu área personal del portal o de la app',
  },
];

export const MODULO_OPINIONS = [
  {
    nameUser: 'Manolo G.',
    title: 'Un equipo muy profesional',
    description:
      'He solicitado una llamada de un médico porque no me encontraba bien y en pocos minutos ya lo tenia al teléfono. Me ha sabido tranquilizar y me ha enviado una receta para retirar la medicación en la farmacia. Muchas gracias Dr. Ruiz',
    // hrefLink: 'https://www.movistar.es'
  },
  {
    nameUser: 'Enrique Fernández González',
    title: '100% recomendable',
    description:
      'La verdad que es una aplicación muy recomendable y el trato excelente la verdad me quedo muy satisfecho muchas gracias',
    // hrefLink: 'https://www.movistar.es'
  },
  {
    nameUser: 'Jos78G',
    title: 'Muy buen servicio',
    description:
      'He utilizado el servicio estando de viaje esquiando y me han resuelto rápidamente el problema enviándome la receta al instante. Un servicio muy recomendable',
    // hrefLink: 'https://www.movistar.es'
  },
];

export const MODULO_TESTIMONIOS = [
  {
    title: 'Tranquilidad y comodidad',
    nameUser: 'Laura Alfonso',
    urlVideo: 'https://www.youtube.com/embed/lDEEuVFIxoY?rel=0',
  },
  {
    title: 'Donde y cuando quieras',
    nameUser: 'Isabel Benavente',
    urlVideo: 'https://www.youtube.com/embed/voGFR2yfVQI?rel=0',
  },
  {
    title: 'Recetas electrónicas',
    nameUser: 'Fernando Soto',
    urlVideo: 'https://www.youtube.com/embed/7E6upgtfJOU?rel=0',
  },
  {
    title: 'Inmediatez',
    nameUser: 'Isabel Aramburu',
    urlVideo: 'https://www.youtube.com/embed/iQb_QWY9rxw?rel=0',
  },
];

export const MODULO_APPS = (device) => [
  {
    align: 'left',
    centerImage: true,
    imgDesktop:
      '/estaticos/imagenes/fichas-producto/movistar-salud/ea-movistar-salud-imagen-12-pc.png',
    altImage: 'app consulta medica',
    title: 'Todos los servicios en la app de Movistar Salud',
    description:
      device === 'pc'
        ? 'Accede a tu médico y a todos los servicios de Movistar Salud<br>desde la app de manera inmediata'
        : 'Accede a tu médico y a todos los servicios de Movistar Salud desde la app de manera inmediata',
    showApps: true,
    apps: [
      {
        name: 'App Store',
        link: 'https://apps.apple.com/es/app/movistar-salud/id1530038482',
        img: 'https://www.movistar.es/estaticos/img/botones/bot-appstore.png',
      },
      {
        name: 'Google Play Store',
        link: 'https://play.google.com/store/apps/details?id=com.movistar.movistarsalud&pli=1',
        img: 'https://www.movistar.es/estaticos/img/botones/bot-googleplay.png',
      },
    ],
  },
];

export const COMERCIAL_CONDITIONS = {
  title: 'Condiciones comerciales',
  description:
    'Promoción válida para nuevas altas hasta el 30 de septiembre de 2023. Precio después de promoción: 6,95€/mes (Programa Personal) y 10,95€/mes (Programa Familiar). Permanencia de 3 meses, que en caso de incumplimiento conlleva el pago de una cuota de 10€, prorrateada en función del tiempo disfrutado. Los Servicios Sanitarios incluidos en Movistar Salud, son prestados por Teladoc Health International, S.A.U. (código sanitario E08680878).',
};

export const VENTAJAS = [
  {
    iconId: 'BigAlarm',
    label: '24 horas',
    sublabel: 'Disponible 24h 7 días a la semana',
  },
  {
    iconId: 'Reloj',
    label: 'Rápido',
    sublabel: 'Habla con un médico en menos de una hora',
  },
  {
    iconId: 'Movil',
    label: 'Desde tu app',
    sublabel: 'Gestión fácil desde la app',
  },
  {
    iconId: 'Equipo',
    label: 'Trato personalizado',
    sublabel: 'Seguimiento de tu salud y trato cercano',
  },
  {
    iconId: 'LlamadaEntrante',
    label: 'Flexible',
    sublabel: 'Agenda una videollamada o pide que te llamen',
  },
  {
    iconId: 'VisitaComercial',
    label: 'Confianza',
    sublabel: 'Médicos expertos en Telemedicina',
  },
];

export const LISTADO_FAQS = [
  {
    title: '¿Quién puede contratar y usar Movistar Salud?',
    content:
      'Puede contratarlo cualquier persona mayor de 18 años y no es necesario que sea previamente cliente de ningún servicio de Movistar.<br></br>Los menores de edad podrán beneficiarse del servicio, pero no podrán gestionar de manera autónoma su cuenta. Necesitarán el permiso y la gestión por parte del titular del servicio.',
  },
  {
    title: 'He contratado Movistar Salud, ¿cómo puedo empezar a utilizarlo?',
    content:
      "Una vez contratado el servicio de telemedicina, te enviaremos un correo electrónico con un enlace a través del cual podrás registrarte y comenzar a disfrutar del programa de salud que has elegido.<br></br>Puedes utilizar el servicio a través de la <a href='https://movistarsalud.es?pid=movistar&_ga=' class='tealium_clic_PA-movistar-salud-faqs-enlace-web-2 GA' target='_blank'>página web</a>, o descargándote la aplicación móvil disponible tanto para sistemas operativos <a href='https://play.google.com/store/apps/details?id=com.movistar.movistarsalud' class='tealium_clic_PA-movistar-salud-faqs-enlace-app-android-2' target='_blank'>Android</a> como <a href='https://apps.apple.com/es/app/id1530038482' class='tealium_clic_PA-movistar-salud-faqs-enlace-app-ios-2' target='_blank'>iOS</a>.",
  },
  {
    title: '¿Cómo funciona la consulta médica online 24/7?',
    content:
      'Existen dos opciones de servicio de <b>telemedicina</b>: solicitar que un médico te llame por teléfono o bien agendar una videollamada, las 24 horas del día.<br></br>En caso de solicitar una llamada telefónica, ésta tendrá lugar, lo más rápidamente posible, típicamente en el transcurso de 1 hora tras tu solicitud. Tan solo tienes que acceder al servicio y solicitarlo.<br></br>En caso de agendar una videollamada, simplemente tienes que acceder a la aplicación móvil o la plataforma web, dónde podrás seleccionar el día y hora que mejor se adapten a tus necesidades en base a la disponibilidad de médicos.',
  },
  {
    title:
      '¿Puede el médico facilitarme de forma online una receta y qué tipo de recetas?',
    content:
      'Sí. En función de su valoración el médico te puede prescribir a través de una receta electrónica la medicación que considera oportuna.<br></br>La receta electrónica te la remitirá por correo electrónico y lleva incorporado un código BIDI de un solo uso.<br></br>Podrás disponer de tu medicamento llevando impreso el correo electrónico a tu farmacia o mostrando el correo directamente en tu teléfono móvil al farmacéutico para que pueda leer el código BIDI.<br></br>Se podrá prescribir – bajo el criterio del médico – cualquier medicamento que esté dentro de la política de prescripción de Teladoc. Los más frecuentes son: antipiréticos, analgésicos y antiinflamatorios.<br></br>El médico también podrá prescribir pruebas diagnósticas o análisis complementarios siempre que lo estime necesario bajo su criterio profesional.',
  },
  {
    title: '¿Quién es Teladoc?',
    content:
      'Teladoc Health es un referente mundial en atención médica virtual integral, capaz de atender a personas desde cualquier parte del mundo, los 365 días del año y 24/7, que está transformando la atención médica y empoderando a las personas para que vivan vidas más saludables.<br></br>El conocimiento y la experiencia de Teladoc Health en España se remonta a más de 20 años, por lo que están preparados para satisfacer las crecientes necesidades de los pacientes y profesionales sanitarios.',
  },
  {
    title:
      '¿Cómo funciona el servicio ‘Ponte en forma: programa online de telemedicina Movistar Salud’?',
    content:
      'Al solicitar el servicio Ponte en Forma respondes a un breve cuestionario online para evaluar tu estado de forma física actual. En base a tus respuestas y prioridades, el programa configura un plan nutricional y de ejercicio físico para 4 u 8 semanas, para conseguir el objetivo de pérdida de peso.<br></br>Durante las semanas que dura el programa, recibes información adicional como propuestas de menús y recetas para seguir una dieta saludable. Además, se te pedirá completar cuestionarios de seguimiento que permitirán evaluar cómo estás avanzando en el programa.<br></br>Si en cualquier momento estimas que necesitas ayuda adicional, podrás solicitar que un nutricionista te llame para evaluar tu caso en mayor detalle y resolver tus dudas.',
  },
  {
    title: '¿Qué médicos online tenemos en nuestro servicio de telemedicina?',
    content:
      'El servicio de Consulta Médica 24/7 da acceso a hablar con médicos de medicina general.<br></br>Todos los médicos incluidos en el servicio de Movistar Salud están colegiados como médicos en el Estado español.',
  },
  {
    title: '¿Qué tipo de consultas médicas online puedo hacer?',
    content:
      'Atención primaria 24/7: puedes realizar una consulta médica online a través de una llamada con un médico de familia (medicina general) en cualquier momento de forma inmediata o agendar una videoconsulta para otro momento. Se trata de un servicio disponible las 24 horas del día, los 365 días del año, consistente en un diagnóstico online y prescripción médica, con posibilidad de recibir una receta médica online en caso de ser necesario.<br></br>Preevaluador de síntomas: funcionalidad basada en inteligencia artificial que permite la preevaluación de los síntomas del usuario y ofrece una recomendación sobre los siguientes pasos a seguir.<br></br>Ponte en forma: programa online de pérdida de peso mediante una dieta específica y una rutina de actividad física adaptada a las necesidades de salud del usuario, en programas de 4 o 8 semanas.<br></br>Los programas de Movistar Salud se irán complementando con nuevas funcionalidades. Te iremos informando tan pronto estén disponibles.',
  },
  {
    title:
      '¿Cómo realizar una videoconsulta en nuestro servicio de telemedicina?',
    content:
      "A través de la aplicación móvil o del portal web del servicio de telemedicina, accedes y seleccionas el servicio de videollamada.<br></br>Escoges el día y hora que mejor se adapte a tus necesidades en base a la disponibilidad de médicos que estará reflejada en tiempo real, y reservas la consulta.<br></br>Llegada la hora reservada, podrás acceder a la sala de espera virtual desde 15 minutos antes de la hora programada.<br></br>A la hora de la consulta:<br><ul style='list-style: disc; margin-left: 20px;'><li>se te habilitará el link de acceso a la videoconsulta entrando en “Mis Citas”.</li><li>selecciona la videollamada concreta estará el médico esperando en la sala de espera.</li><li>Te mandaremos un email recodando la cita 15min antes de la misma, recuerda ser puntual para que la cita no sea cancelada.</li></ul>",
  },
  {
    title: '¿Dónde consigo la app de telemedicina de Movistar Salud?',
    content:
      "La aplicación estará disponible para su descarga tanto en <a href='https://play.google.com/store/apps/details?id=com.movistar.movistarsalud' class='tealium_clic_PA-movistar-salud-faqs-enlace-app-android-3' target='_blank'>Google Play</a>, si tu terminal es Android, como en la <a href='https://apps.apple.com/es/app/id1530038482' class='tealium_clic_PA-movistar-salud-faqs-enlace-app-ios-3' target='_blank'>App Store</a> para terminales con sistema operativo iOS.",
  },
  {
    title: '¿Dónde puedo usar Movistar Salud?',
    content:
      'Puedes utilizar tu programa de Movistar Salud en cualquier lugar del mundo que tenga una conexión a Internet.<br></br>En caso de encontrarte en el extranjero y querer utilizar los servicios de Movistar Salud, solo tendrás que facilitar cuál es el país en el que te encuentras para garantizar una correcta atención médica.',
  },
  {
    title: '¿Qué programas de telemedicina hay?',
    content:
      'Tenemos dos programas de telemedicina diseñados para adaptarse a tus necesidades: un programa personal y un programa familiar.<br></br>En el programa personal únicamente el titular podrá utilizar el servicio, mientras que en el programa familiar el titular puede añadir un beneficiario adicional mayor de edad y un número ilimitado de usuarios menores de edad dentro de una misma unidad familiar para que disfruten del servicio.',
  },
  {
    title: '¿Cómo funciona la preevaluación digital de síntomas?',
    content:
      'Una vez que entras a nuestro servicio de telemedicina, accedes a un cuestionario online y dinámico basado en inteligencia artificial, que adapta las preguntas nuevas en base a las respuestas que vas introduciendo, hasta lograr orientarte en tu diagnóstico o recomendarte los próximos pasos más adecuados.<br></br>El uso del programa de preevaluación digital de síntomas es ilimitado y lo pueden utilizar todos los usuarios del servicio de telemedicina, incluyendo beneficiarios y dependientes pueden apuntarse al programa.',
  },
  {
    title: '¿Cómo puedo darme de baja del servicio de telemedicina?',
    content:
      "Para darte de baja puedes llamar al <a href='tel:1004' target='_blank'>1004</a> y procederán a tramitar tu solicitud.<br></br>Ten en cuenta que el servicio tiene un compromiso mínimo de contratación de 3 meses con lo que debes confirmar durante el proceso si hay algún tipo de coste asociado.",
  },
  {
    title: '¿Qué es la telemedicina?',
    content:
      'Al hablar de telemedicina nos referimos a la conexión que se mantiene entre médico y paciente que no se lleva a cabo de forma presencial, sino mediante la utilización de dispositivos asociados a las nuevas tecnologías de la información y la comunicación, como un ordenador o un dispositivo móvil.<br></br>La telemedicina permite evitar tiempo y desplazamientos innecesarios al paciente en gran parte de los casos, facilitando el acceso a la atención médica a la población.',
  },
  {
    title: '¿Es Movistar Salud un seguro médico?',
    content:
      'No, no es un seguro médico. Movistar Salud es un servicio de telemedicina con las características y funcionalidades detallados en la información de los programas de salud familiar y personal respectivamente. Si no dispones de un seguro privado te puede ayudar al permitir el contacto con un médico de atención primaria desde tu hogar, sin desplazamientos ni esperas.',
  },
];

export const TABS_IDS = {
  PLAN_PERSONAL: 'planpersonal',
  PLAN_FAMILIAR: 'planfamiliar',
};

export const SWITCH_OPTIONS = [
  { label: 'Plan Personal', value: 'planpersonal' },
  { label: 'Plan Familiar', value: 'planfamiliar' },
];
